import { AxiosResponseHeaders } from 'axios';
import {
  AccountExtraitTransactionsPrint,
  AccountExtraitTransactionsPrintResponseDTO,
} from '../../entities/AccountExtraitTransaction/AccountExtraitTransactionsPrintResponseDTO';

const AccountExtraitTransactionsPrintResponseDTOtoTransactionPrintAdapter = (
  response: AccountExtraitTransactionsPrintResponseDTO,
  headers?: AxiosResponseHeaders,
): AccountExtraitTransactionsPrint => {
  if (!response.body) {
    throw Error();
  }

  return {
    report: response.body.report,
  };
};

export { AccountExtraitTransactionsPrintResponseDTOtoTransactionPrintAdapter };
